module.exports = __webpack_public_path__ + "static/media/slider-17.1a29299f.jpg";